export default __webpack_public_path__ + "static/media/image-2.9b2cde24.svg";